var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',[_vm._v(_vm._s(_vm.model.functionName)+" "),_c('b-badge',{staticClass:"float-right home-inbox-counter",attrs:{"pill":"","variant":"warning"}},[_vm._v(_vm._s(_vm.model.totalInbox))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }